export const FIELD_TYPE_MAP: Record<string, FieldType> = {
  product: 'multi_dropdown',
  name: 'string',
  street_address: 'string', 
  city: 'string',
  state: 'single_dropdown',
  zip_code: 'string',
  
  recorded_owner: 'string',
  true_owner: 'string', 
  pmc: 'string',
  
  pms: 'single_dropdown',
  crm: 'single_dropdown',

  pricing_availability: 'single_dropdown',
  calendar: 'single_dropdown',
  training_system: 'single_dropdown',
  affordable_income_restricted: 'boolean',
  affordable_section_8: 'boolean',
  new_construction: 'boolean',
  student: 'boolean',
  
  total_units: 'integer',
  property_website: 'string_website',
  property_email: 'string_email',  
  property_phone: 'string',
  
  contract_signer: 'single_person',
  regional_manager: 'single_person',
  community_manager: 'multi_person',
  operational_team_member: 'multi_person',
  marketing_team_member: 'multi_person', 
  implementation_team_member: 'multi_person',
  invoice_recipient: 'multi_person',
  secondary_invoice_recipient: 'multi_person',
  regional_supervisor: 'multi_person',
  regional_marketing_supervisor: 'multi_person',
  regional_vice_president: 'multi_person',
  // Implementation Contacts (new)
  project_lead_team_member: 'multi_person',
  resident_team_member: 'multi_person',
  technical_team_member: 'multi_person',
  voice_team_member: 'multi_person',
  knowledge_team_member: 'multi_person',
  training_team_member: 'multi_person',
  owner_team_member: 'multi_person',
  
  // PLG fields (session-level, but included here for completeness)
  ai_name: 'string',
  elisego_name: 'string',
  schedule_tours: 'boolean',
  voice_area_code: 'integer',
  
  invoice_submission_type: 'single_dropdown',
  client_billing_id: 'string',
  client_property_id: 'string',
} as const;

export type FieldType = 
  | 'string' 
  | 'string_email'
  | 'string_website'
  | 'integer'
  | 'single_dropdown'
  | 'multi_dropdown' 
  | 'single_person'
  | 'multi_person'
  | 'boolean';

export function getFieldType(fieldKey: string): FieldType {
  return FIELD_TYPE_MAP[fieldKey] || 'string';
}

export function isPersonField(fieldType: FieldType): boolean {
  return fieldType === 'single_person' || fieldType === 'multi_person';
}

export function isDropdownField(fieldType: FieldType): boolean {
  return fieldType === 'single_dropdown' || fieldType === 'multi_dropdown';
}